import React, { useMemo } from 'react';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';

const PurchaseOrderInvoicesTable = (props) => {

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.purchaseOrders.length; i++ ) {
      const purchaseOrder = props.purchaseOrders[i];
      if(purchaseOrder.payments.length > 0) {
        const purchaseOrderVendor = props.vendors.find(vendor => vendor.id === purchaseOrder.vendorId);
        for ( let j = 0; j < purchaseOrder.payments.length; j++ ) {
          const payment = purchaseOrder.payments[j];
          initialTableData.push({
            displayId: payment.displayId,
            poDisplayId: purchaseOrder.displayId,
            name: purchaseOrderVendor.name,
            createdAt: moment(payment.createdAt).format('DD/MM/YYYY'),
            amount: payment.amount,
            total: purchaseOrder.total
          });
        }
      }
    }

    return initialTableData;
    
  }, [props.purchaseOrders, props.vendors]);

  const columns = [
    { label: "Invoice ID", name: "displayId" },
    { label: "P.O. ID", name: "poDisplayId" },
    { label: "Vendor Name", name: "name" },
    { label: "Payment Date", name: "createdAt" },
    { label: "Amount", name: "amount" },
    { label: "Total", name: "total" }
  ];

  const options = {
    selectableRows: "none"
  };

  return (
    <MUIDataTable 
      title={"Purchase Invoices"}
      data={tableData}
      columns={columns}
      options={options}
    />
  )
};

export default PurchaseOrderInvoicesTable;